/**
 * Channel filter search component.
 */
import Container from '../../atoms/container/channelFilterSearchContainer';
import Icon from '../../atoms/icons/searchButton';
import Press from '@components/atoms/container/channelFilterPressContainer';
import Title from './channelFilterTitle';
import TranslationManager from '@shared/assets/locale/translationsManager';
import useList from '@shared/components/utils/hooks/useList';
import { magicRemoteSelector } from '@shared/store/slices/magicRemote.slice';
import { useAppSelector } from '@shared/store/hooks';

/**
 * Props for the channel filter search component
 */
interface Props {
  hideSearch?: boolean;
  hideTitle?: boolean;
  index: number;
  action?: () => void;
}

/**
 * Channel filter search component.
 * Renders the channel filter search with a search icon and a press component.
 */
export default function ChannelFilterSearch({
  action,
  index,
  hideSearch,
  hideTitle = false,
}: Props) {
  const { enabled } = useAppSelector(magicRemoteSelector);
  const { listIndex, focused } = useList(index);
  return (
    <>
      {!hideSearch ? (
        <Container
          focused={!enabled && focused && listIndex === index}
          onClick={action}
        >
          <Icon />
          <Press>{TranslationManager.get('COMPONENTS.FILTER.SEARCH')}</Press>
        </Container>
      ) : null}
      {!hideTitle ? <Title /> : null}
    </>
  );
}
